"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/web.dom.iterable");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _search = _interopRequireDefault(require("./components/search.vue"));
var _nav = _interopRequireDefault(require("@/components/nav.vue"));
var _newsMenhu = require("@/api/news/newsMenhu");
var _news = require("@/api/news/news");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Search: _search.default,
    Nav: _nav.default
  },
  filters: {
    date: function date(val) {
      if (val) return val.slice(0, 10);
    },
    day: function day(val) {
      if (val) return val.slice(8, 10);
    },
    year: function year(val) {
      if (val) return val.slice(0, 7);
    }
  },
  data: function data() {
    return {
      tabList: [{
        type: ''
      }],
      curIndex: 0,
      list: [],
      query: {
        upperShelf: 1,
        newsTypeId: '',
        newsTitle: '',
        pageNum: 1,
        pageSize: 20
      },
      total: 20,
      loading: false
    };
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return this.getNewsTypeList();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  methods: {
    //获取新闻分类
    getNewsTypeList: function getNewsTypeList() {
      var _this = this;
      (0, _newsMenhu.newsTypeList)().then(function (res) {
        _this.tabList = res.rows;
        if (_this.tabList.length > 0) {
          // this.query.newsTypeId = this.tabList[0].id
          _this.tabList.forEach(function (i, j) {
            if (i.type == '通知公告') {
              _this.curIndex = j;
              _this.query.newsTypeId = _this.tabList[j].id;
              _this.getnewslist_met();
            }
          });
        }
      });
    },
    //获取新闻列表
    getnewslist_met: function getnewslist_met() {
      var _this2 = this;
      this.loading = true;
      (0, _newsMenhu.newsListMenhu)(this.query).then(function (res) {
        _this2.list = res.rows;
        _this2.total = res.total;
        console.log('新闻列表--', _this2.list);
        _this2.loading = false;
      });
    },
    tabs: function tabs(i, j) {
      this.curIndex = j;
      this.query.newsTypeId = i.id;
      this.getnewslist_met();
    },
    lookDetail: function lookDetail(i) {
      var type;
      for (var u in this.tabList) {
        if (this.tabList[u].id.toString() == i.newsTypeId) {
          // console.log('ppp')
          type = this.tabList[u].type;
        }
      }
      if (i.newsUrl && i.newsUrl.length > 5) {
        window.open(i.newsUrl, "_blank");
      } else {
        this.$router.push({
          path: "/newsDetail",
          query: {
            id: i.id,
            type: type
          }
        });
      }
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.query.pageNum = e;
      this.getnewslist_met();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.query.pageSize = e;
      this.query.pageNum = 1;
      this.getnewslist_met();
    },
    toSsearch: function toSsearch(e) {
      // console.log('dianji', e)
      this.query.newsTitle = e.courseName;
      this.query.newsTypeId = e.typeName;
      this.curIndex = null;
      for (var i in this.tabList) {
        if (this.tabList[i].id == e.typeName) {
          this.curIndex = i;
        }
      }
      this.query.pageNum = 1;
      this.getnewslist_met();
    }
  }
};